import React from 'react';

interface CurrencyIconProps {
  className?: string;
  title?: string;
  variant?: 'coin' | 'palm';
}

const CurrencyIcon: React.FC<CurrencyIconProps> = ({ className, title, variant = 'coin' }) => {
  const src = variant === 'palm' ? '/palm.jpeg' : '/coin.jpeg';
  const label = title || (variant === 'palm' ? 'Earned points' : 'Coins');

  return (
    <img
      className={className}
      src={src}
      alt={label}
      title={label}
      draggable={false}
    />
  );
};

export default CurrencyIcon;
